
import './PageDetails.css'
import { useState } from 'react'

const PageDetails = props => {
  const {Appitem} = props
  const {categoryDetails, imageUrl, category,features,specifications,content,heading} = Appitem
  console.log(category)
  return (
    <div className="appItemcontainer">
      {/* Render the table based on the category */}
      {renderTableBasedOnCategory(category, categoryDetails,imageUrl,features,specifications,heading,content)}
    </div>
  )
}



const renderTableBasedOnCategory = (category, categoryDetails,imageUrl,features,specifications,heading,content) => {
  switch (category) {
    case 'SOCIAL':
      return (
        <table id="customers" style={{marginBottom:"50px"}}>
          <tr>
            <th style={{textAlign:"center"}}>Inspection Type</th>
            <th style={{textAlign:"center"}}>Description</th>
            <th style={{textAlign:"center"}}>Action Required</th>
          </tr>
          {categoryDetails.map((each, index) => (
            <tr key={index}>
              <td>{each.InspectionItem}</td>
              <td>{each.Description}</td>
              <td>{each.ActionRequired}</td>
            </tr>
          ))}
        </table>
      )
    case 'GAMES':
      // Return JSX for GAMES category
      return (
        <>
        <div className='machine_container'>
            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/inspection1.jpeg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Cut to Length Machine</span>
              </div>
             
            </div>

            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/inspection2.jpeg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Perforation Machine</span>
              </div>
            </div>

            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/56.jpg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Manufacturing Machine</span>
              </div>
            </div>

            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/57.jpg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Testing Machine</span>
              </div>
            </div>

            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/58.jpg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Air Filter Checking Machine</span>
              </div>
            </div>

           

        </div>
        
        
        </>
      )
    case 'NEWS':
      // Return JSX for NEWS category
      return (
        <div className="air-filter-test-rig">
          <div>
             <h1>{heading}</h1>
             <p>{content}</p>
          </div>
      <h2>Features</h2>
      <ul>
        {features.map((feature, index) => (
          <li key={index} >{feature}</li>
        ))}
      </ul>

      <h2>Specifications</h2>
      <ul style={{textAlign:"justify"}}>
        {specifications.map((spec, index) => (
          <li key={index}>{spec}</li>
        ))}
      </ul>
    </div>
      )
    case 'FOOD':
      return (
        <>
           <div className='machine_container'>
            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/verniercliper.jpg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Digital Vernier <br/>Caliper</span>
              </div>
            </div>

            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/ringgange.webp" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Ring Gauge</span>
              </div>
            </div>
           
            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/gonogo.webp" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Go & Non-Go</span>
              </div>
            </div>

            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/screwgange.jpg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Screw Gauge</span>
              </div>
            </div>

            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/heightverniercliper.jpg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Height Vernier Caliper</span>
              </div>
            </div>

            <div class="card_7">
              <div class="first-content_7">
                <img src="./images/airfilterinspection.jpg" alt="" className='image_7'/>
              </div>
              <div class="second-content_7">
            <span style={{color:"white"}}>Filteration System Inspection</span>
              </div>
            </div>
           
        </div>

       
        </>
      )
    default:
      return null
  }
}

export default PageDetails